import { render, staticRenderFns } from "./ModalVehicleSupport.vue?vue&type=template&id=07be5cb3&"
import script from "./ModalVehicleSupport.vue?vue&type=script&lang=js&"
export * from "./ModalVehicleSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports